import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  useToggle
} from '@lucidhq/lucidium';

import {
  CampaignPixelVariables,
  useAddCampaignPixelGroup
} from '~/components/Shared/hooks/useMutateCampaignPixelGroup';
import { t } from '~/utils/i18n';

import { useCampaignManager } from '../../CampaignManagerProvider';
import { SiteServedTagForm } from './SiteServedTagForm';

type CreateSiteServedTagProps = {
  campaignId: string;
  onCreate: () => void;
  children: ({ onToggle }: { onToggle: () => void }) => React.ReactNode;
};

export const CreateSiteServedTag = ({
  children,
  campaignId,
  onCreate
}: CreateSiteServedTagProps) => {
  const { onMutateError } = useCampaignManager();
  const [isOpen, handleToggle] = useToggle(false);
  const { mutate, isLoading } = useAddCampaignPixelGroup(campaignId);

  const handleSubmit = (params: CampaignPixelVariables) => {
    mutate(
      {
        campaign_pixels: [params]
      },
      {
        onSuccess: () => {
          onCreate();
          handleToggle();
        },
        ...onMutateError
      }
    );
  };

  return (
    <>
      {children({ onToggle: handleToggle })}
      <Dialog isOpen={isOpen} onClose={handleToggle} lss={{ width: '43rem' }}>
        <DialogHeader palette="disabled" onClose={handleToggle}>
          {t('campaignManager.mediaTracking.siteServed.title')}
        </DialogHeader>
        <DialogContent>
          <SiteServedTagForm
            isLoading={isLoading}
            onCancel={handleToggle}
            onSubmit={handleSubmit}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
